import type { FormTemplateItemType } from './form-template-item-type.enum'

export class FormTemplateItem {
    id: string
    label: string
    type: FormTemplateItemType
    required: boolean
    enabled: boolean
    another: boolean
    content: string[]
    contentScore: string[]
    locked: boolean
    score: boolean
}
